import * as React from "react";
import ReactDOM from "react-dom";
import "./style.css";

interface TooltipProps {
    content: React.ReactNode;
    children: React.ReactNode;
    offsetY?: number;
}

const Tooltip: React.FC<TooltipProps> = ({
    content,
    children,
    offsetY = 0
}) => {
    const [visible, setVisible] = React.useState(false);
    const triggerRef = React.useRef<HTMLDivElement>(null);

    const stopMouseEvents = (e: React.SyntheticEvent) => {
        e.stopPropagation();
    };

    const tooltip =
        visible && triggerRef.current
            ? ReactDOM.createPortal(
                  <div
                      className="tooltip"
                      style={{
                          position: "absolute",
                          top:
                              triggerRef.current.getBoundingClientRect()
                                  .bottom +
                              window.scrollY +
                              offsetY,
                          left:
                              triggerRef.current.getBoundingClientRect().left +
                              window.scrollX
                      }}
                      onMouseDown={stopMouseEvents}
                      onMouseUp={stopMouseEvents}
                      onClick={stopMouseEvents}
                      onDoubleClick={stopMouseEvents}
                      onPointerDown={stopMouseEvents}
                      onPointerUp={stopMouseEvents}
                      onContextMenu={stopMouseEvents}
                      tabIndex={-1}
                      onMouseEnter={() => setVisible(true)}
                      onMouseLeave={() => setVisible(false)}
                  >
                      {content}
                  </div>,
                  document.body
              )
            : null;

    return (
        <>
            <div
                ref={triggerRef}
                style={{ display: "inline-block", position: "relative" }}
                onMouseEnter={() => setVisible(true)}
                onMouseLeave={() => setVisible(false)}
            >
                {children}
            </div>
            {tooltip}
        </>
    );
};

export default Tooltip;
